import React from "react";
import { motion } from "framer-motion";

const Hero = () => {
  return (
    <section className="hero">
      <style>{`
        .hero {
          background: linear-gradient(180deg, #143414, #1f441e);
          color: #fff;
          min-height: 100vh; /* ✅ علشان ياخد طول الشاشة بالكامل */
          display: flex;
          align-items: center; /* ✅ توسيط عمودي */
          justify-content: center; /* ✅ توسيط أفقي */
          text-align: center;
          padding: 0 20px;
          font-family: "Cairo", sans-serif;
        }

        .hero__content {
          max-width: 750px;
        }

        .hero__title {
          font-size: 2.4rem;
          font-weight: 700;
          line-height: 1.5;
          margin-bottom: 18px;
        }

        .hero__highlight {
          color: #9cd47a; /* ✅ لون مميز لاسم المحامي */
        }

        .hero__subtitle {
          font-size: 1.05rem;
          color: #d8e5d8;
          margin-bottom: 35px;
          line-height: 1.9;
        }

        .hero__button {
          background: #9cd47a;
          color: #143414;
          padding: 14px 30px;
          border-radius: 10px;
          font-weight: 700;
          text-decoration: none;
          transition: all 0.3s ease;
          display: inline-block;
        }

        .hero__button:hover {
          background: #b8f28f;
          transform: translateY(-2px);
        }

        @media (max-width: 768px) {
          .hero__title {
            font-size: 1.8rem;
          }
          .hero__subtitle {
            font-size: 0.95rem;
          }
        }

        @media (max-width: 480px) {
          .hero__title {
            font-size: 1.5rem;
          }
          .hero__button {
            padding: 12px 20px;
            font-size: 0.9rem;
          }
        }
      `}</style>

      <motion.div
        className="hero__content"
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >
        <h1 className="hero__title">
          مؤسسة <span className="hero__highlight">محمد إبراهيم أبو عدبه</span>{" "}
          للمحاماة والاستشارات القانونية
        </h1>
        <p className="hero__subtitle">
          خبرة تمتد لأكثر من 20 عامًا في مختلف فروع القانون — نؤمن بأن العدالة
          أساس كل مجتمع ونحرص على تحقيق أعلى درجات النزاهة لخدمة عملائنا.
        </p>
        <a href="contact" className="hero__button">
          تواصل معنا الآن
        </a>
      </motion.div>
    </section>
  );
};

export default Hero;
